export class FbUserSeeding {
  _id = '';
  userId = '';
  username = '';
  email = '';
  status = false;
  canChat = false;
  seedingPositive = false;
  allow_seeding_bot = false;
  proxyHost = '';
  proxyPort = null;
  proxyUser = '';
  proxyPassword = '';
  facebookCookie = '';
  userAgent = '';
  messengerCookie = '[]';
  isEdit = false;
  passwordConf = '';
  password = '';
  oldPassword = '';
  adminPassword = '';
  emailErrorMsg = '';
  project = null;
  tokenUser = '';
  image = '';
  vps_hosting_id = '';
  vps_hosting_ip = '';
  vps_hosting_name ='';
  allowedToChange = false;
  type: Array<string>;
  hasVnptAvt = false;
  // type = [];

  set(fbUserSeeding) {
    this._id = fbUserSeeding['_id'];
    this.username = fbUserSeeding['username'];
  }

  checkEmail() {
    this.emailErrorMsg = '';
    if (this.email === '') {
      this.emailErrorMsg = 'Bạn chưa nhập email!';
    } else {
      const emailPattern = '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$';
      if (this.email.toLowerCase().match(emailPattern) === null) {
        this.emailErrorMsg = 'Email của bạn không đúng định dạng!';
      }
    }
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_models/fb-user-seeding.ts